import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { OneSelectDropdownModule, OneFormFieldModule } from '@one/angular-kit/form';
import { MatListModule } from '@angular/material/list';
import { OneListModule } from '@one/angular-kit/layout';
import { OneTableModule } from '@one/angular-kit/data-table';
import { MatTableModule } from '@angular/material/table';
import { CdkTableModule } from '@angular/cdk/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSortModule } from '@angular/material/sort';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatMenuModule } from '@angular/material/menu';
import { OneMenuModule } from '@one/angular-kit/navigation';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatRadioModule } from '@angular/material/radio';
import { MatChipsModule } from '@angular/material/chips';
import { OneChipModule } from '@one/angular-kit/indicator';
import { MatTooltipModule } from '@angular/material/tooltip';
import { OneSnackBarModule, OneTooltipModule } from '@one/angular-kit/modal';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { DueDateReminderComponent } from './due-date-reminder.component';
import { CreateReminderComponent } from './create-reminder/create-reminder.component';
import { ReminderTableComponent } from './reminder-table/reminder-table.component';
import { ReminderDatePickerComponent } from './create-reminder/reminder-date-picker/reminder-date-picker.component';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { RichTextDocumentFeatureModule } from '../richTextDocument/rich-text-document.module';
import { ReminderMessageTemplateDialogComponent } from './create-reminder/reminder-message-template-dialog/reminder-message-template-dialog.component';
import { ReminderMessageTemplateComponent } from './create-reminder/reminder-message-templete/reminder-message-template.component';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';

@NgModule({
  declarations: [DueDateReminderComponent, CreateReminderComponent, ReminderTableComponent, ReminderDatePickerComponent,ReminderMessageTemplateDialogComponent,ReminderMessageTemplateComponent],
  imports: [CommonModule, MatMenuModule, OneMenuModule, MatButtonToggleModule, RichTextDocumentFeatureModule, OneTooltipModule, MatTooltipModule, OneChipModule, MatChipsModule, MatDatepickerModule, MatNativeDateModule, MatDialogModule, MatFormFieldModule, MatInputModule, MatSelectModule, OneFormFieldModule, MatCheckboxModule, MatSortModule, DragDropModule, OneTableModule, MatTableModule, MatCardModule, CdkTableModule, MatIconModule, MatListModule, OneListModule, MatButtonModule, OneSelectDropdownModule, FormsModule, ReactiveFormsModule, MatRadioModule,OneSnackBarModule, MatSlideToggleModule],
  exports: [DueDateReminderComponent],
  providers: [{ provide: MAT_DATE_LOCALE, useValue: 'en-GB' }]
})
export class DueDateReminderModule {}
